import { render, staticRenderFns } from "./logistics-trade.vue?vue&type=template&id=d6e7c19e&scoped=true"
import script from "./logistics-trade.vue?vue&type=script&lang=js"
export * from "./logistics-trade.vue?vue&type=script&lang=js"
import style0 from "./logistics-trade.vue?vue&type=style&index=0&id=d6e7c19e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e7c19e",
  null
  
)

export default component.exports